import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";


import { ShowRecommendedProductsPage } from "./show-recommended-products.page";
import { CardPageModule } from "../card/card.module";
import { TranslateModule } from "@ngx-translate/core";
import { PipesModule } from "src/app/shared/pipe/pipe.module";
import { MpImgPageModule } from '../image-tag/image-tag.module';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
	imports: [
		CommonModule,
		FormsModule,
		CardPageModule,
		TranslateModule,
		PipesModule,
		MpImgPageModule,
	],
	declarations: [ShowRecommendedProductsPage],
	exports: [ShowRecommendedProductsPage],
})
export class ShowRecommendedProductsPageModule {}
